import Image from "next/image";
import ShareIcon from "../../../../../../../shared-assets/images/funUgc/player/ShareIcon.png";
import { UGCList } from "../../../../../../models/home-rows";
import styles from "./ProductShare.module.scss";
import { GetUgcFileType } from "../../helpers";
import { useEffect, useState } from "react";
import { FileType, UGCType } from "../../models/funUgc.model";

interface ProductShareProps {
  ugc: UGCList;
}

export function ProductShare({ ugc }: ProductShareProps) {
  const [ugcTypeName, setUgcTypeName] = useState("");
  const [ugcTypeRoute, setUgcTypeRoute] = useState("");

  useEffect(() => {
    switch (ugc.ugc_type) {
      case UGCType.Dub:
        setUgcTypeName("دوبله");
        setUgcTypeRoute("dub");
        return;
      case UGCType.Story:
        setUgcTypeName("قصه");
        setUgcTypeRoute("story");
        return;
      case UGCType.Painting:
        setUgcTypeName("نقاشی");
        setUgcTypeRoute("painting");
        return;
      case UGCType.Coloring:
        setUgcTypeName("رنگ‌آمیزی");
        setUgcTypeRoute("coloring");
        return;
      case UGCType.Gallery:
        setUgcTypeName("ویدئو");
        setUgcTypeRoute("gallery");
        return;
      case UGCType.Dubsmash:
        setUgcTypeName("دابسمش");
        setUgcTypeRoute("dubsmash");
        return;
      default:
        break;
    }
  }, []);

  const handleShare = async (ugc: UGCList) => {
    const shareLink = `https://www.digitoon.tv/fun/ugc/${ugcTypeRoute}/${ugc.id}`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: "دیجیتون", // Replace with your title
          text: `این ${ugcTypeName} با دیجیتون فان ساخته شده. \n تو هم امتحانش کن. \n`, // Replace with your text
          url: shareLink // Share the current URL
        });
      } else {
        console.log(
          "Sorry, Your device does not support share option!",
          shareLink
        );
      }
    } catch (error) {
      console.error("Sharing Error: ", error);
    }
  };

  return (
    <>
      <div
        className={styles.productShareWrapper}
        onClick={async () => {
          await handleShare(ugc);
        }}
      >
        <div className={styles.shareImageWrapper}>
          <Image src={ShareIcon} alt="" layout="fill" priority={true} />
        </div>
      </div>
    </>
  );
}
